import React, { useContext, useEffect } from 'react';
import CreationForm from './components/CreationForm/CreationForm';
// import TranslationsForm from './components/TranslationForm/TranslationsForm';
import { CreateTeaserContext, ICreateTeaserContext } from '../../createTeaserState/createTeaserContext';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { visibleForm } = useContext<ICreateTeaserContext>(CreateTeaserContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	return (
		<div className={style.container} data-test="Forms">
			<CreationForm isVisible={visibleForm === 'mainForm'} />
			{/* <TranslationsForm isVisible={visibleForm === 'translations'} /> */}
		</div>
	);
};

export default Forms;
